
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/face_analyzer",
      function () {
        return require("private-next-pages/face_analyzer/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/face_analyzer"])
      });
    }
  